import React from 'react';

const Appointments = () => {
    return (
        <section id="appointments" className="block bg-gray-light spacer p-top-xl p-bottom-xl">
            <div className="wrapper">
                <div className="title text-max-width">
                    <h2>Our Appointments</h2>
                </div>

                <div className="description">
                    <p>Here are all the various appointments we offer to our clients.</p>
                    <br /> 
                </div>

                <div className="row product">
                    <div className="col-md-6 product-detail">
                        <h4>ACC Initial Appointment</h4>
                        <p>Includes assessment, treatment, and notes.</p> <br />
                    </div>
                </div>

                <div className="row product">
                    <div className="col-md-6 product-detail">
                        <h4>ACC Follow Up Appointment</h4>
                        <p>30 minutes including treatment, and notes.</p> <br />
                    </div>
                </div>

                <div className="row product">
                    <div className="col-md-6 product-detail">
                        <h4>Private Initial Appointment</h4>
                        <p>Includes assessment, treatment, and notes.</p> <br />
                    </div>
                </div>

                <div className="row product">
                    <div className="col-md-6 product-detail">
                        <h4>Private Follow Up Appointment</h4>
                        <p>30 minutes including treatment, and notes.</p> <br />
                    </div>
                </div>
                
                <div className="notice">
                    <h5> Notice: </h5>
                    <p>
                        Should you fail to notify us at least 4 HOURS IN ADVANCE that you no longer require your appointment, you will 
                        be liable for a non-attendance fee of $60.
                    </p>
                </div>

                <div className="extras">
                    <br /> <br /> <br /> <p>We also offer various products in clinic for sale such as Wheat Bags, formthotics, braces, muscle rub and strapping tape. Check them out when you attend your appointment.</p>
                </div>
            </div>
        </section>
    );
};

export default Appointments;
